(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["movement-row"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-movement-row]').forEach((row) => {
    const track = row.querySelector('[data-movement-row-track]');
    const prevButton = row.querySelector('[data-movement-row-prev]');
    const nextButton = row.querySelector('[data-movement-row-next]');
    if (!track) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const updateArrows = () => {
      const hasOverflow = track.scrollWidth > track.clientWidth + 2;
      row.classList.toggle('movement-row--no-overflow', !hasOverflow);
      if (prevButton) prevButton.disabled = track.scrollLeft <= 2;
      if (nextButton) {
        nextButton.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      }
    };

    // Targets the actual next/previous card via scrollIntoView rather than a
    // hand-computed pixel offset via scrollBy — cooperates cleanly with
    // scroll-snap-align: start on each card, and matches the same technique
    // already proven in sections/swingfly-weight-selector.liquid's carousel.
    const scrollByCard = (direction) => {
      const cards = Array.from(track.querySelectorAll('[data-movement-card]'));
      if (!cards.length) return;
      const currentLeft = track.scrollLeft;
      let targetIndex = direction > 0 ? cards.length - 1 : 0;
      if (direction > 0) {
        const next = cards.findIndex((card) => card.offsetLeft > currentLeft + 4);
        if (next !== -1) targetIndex = next;
      } else {
        for (let i = 0; i < cards.length; i += 1) {
          if (cards[i].offsetLeft < currentLeft - 4) targetIndex = i;
        }
      }
      cards[targetIndex].scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        inline: 'start',
        block: 'nearest',
      });
    };

    if (prevButton) prevButton.addEventListener('click', () => scrollByCard(-1));
    if (nextButton) nextButton.addEventListener('click', () => scrollByCard(1));

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    row.querySelectorAll('[data-movement-play]').forEach((playButton) => {
      playButton.addEventListener('click', () => {
        const media = playButton.closest('[data-movement-media]');
        const template = media ? media.querySelector('[data-movement-video-template]') : null;
        if (!media || !template) return;
        media.innerHTML = '';
        media.appendChild(template.content.cloneNode(true));
        const video = media.querySelector('video');
        if (video) video.play().catch(() => {});
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swingfly-weight-selector"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sf-weight-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-sf-weight-track]');
    const prevButton = carousel.querySelector('[data-sf-weight-prev]');
    const nextButton = carousel.querySelector('[data-sf-weight-next]');
    const dotsContainer = carousel.querySelector('[data-sf-weight-dots]');

    // DOM order is 480, then 750 (matches block_order, so desktop's grid —
    // unaware of `order` — renders unchanged). Visual/scroll order at
    // mobile is 750, then 480, via the CSS `order` values set above (1, 2).
    // Sort by that so slide indices, dot labels, and the initial active dot
    // all line up with what's actually scrolled into view first, not with
    // source order.
    const slides = Array.from(carousel.querySelectorAll('[data-sf-weight-slide]')).sort(
      (a, b) => parseInt(getComputedStyle(a).order, 10) - parseInt(getComputedStyle(b).order, 10)
    );

    if (!track || slides.length === 0) return;

    // Start every visit on the first slide, regardless of the DOM order
    // above or any scroll position the browser tries to restore.
    track.scrollLeft = 0;

    // Build the position-indicator dots to match however many slides
    // actually rendered (normally 2: 750, 480).
    const dots = slides.map((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sf-weight__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      dot.addEventListener('click', () => {
        slides[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      dotsContainer.appendChild(dot);
      return dot;
    });

    const setActive = (activeIndex) => {
      dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
      });
    };

    // Track which slide is centered in view to keep the dots in sync with
    // swipes/arrow clicks alike, without polling scroll position by hand.
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            setActive(slides.indexOf(entry.target));
          }
        });
      },
      { root: track, threshold: [0.6] }
    );
    slides.forEach((slide) => observer.observe(slide));

    const scrollByOne = (direction) => {
      const currentIndex = dots.findIndex((dot) => dot.getAttribute('aria-current') === 'true');
      const targetIndex = Math.min(Math.max(currentIndex + direction, 0), slides.length - 1);
      slides[targetIndex].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    };

    if (prevButton) prevButton.addEventListener('click', () => scrollByOne(-1));
    if (nextButton) nextButton.addEventListener('click', () => scrollByOne(1));
  });

  } catch(e) { console.error(e); }
})();
})();
